import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Phone, Award, ArrowRight } from "lucide-react";

const BUSINESS_PHONE_LINK = "tel:+33549057490";

const AppleLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

export const PhoneHero = () => (
  <section className="relative py-16 md:py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute top-20 left-10 w-72 h-72 bg-red-500 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
    </div>

    <div className="container-custom relative">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <div className="flex flex-wrap gap-3">
            <Badge className="bg-slate-800 text-white px-5 py-2.5 text-sm font-bold border border-slate-700 shadow-lg">
              <AppleLogo className="w-5 h-5 mr-2" />
              Apple
            </Badge>
            <Badge className="bg-red-700 text-white px-5 py-2.5 text-sm font-bold shadow-lg">
              <Award className="w-5 h-5 mr-2" />
              Techniciens Certifiés
            </Badge>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-300">Techniciens Certifiés</span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-600">Apple</span>
          </h1>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed max-w-xl">
            Experts en réparation <strong className="text-white">iPhone, iPad, MacBook et iMac</strong> depuis plus de 10 ans.
            Également spécialistes <strong className="text-white">Samsung, Huawei, Xiaomi</strong> et toutes marques.
          </p>

          <div className="grid grid-cols-3 gap-4 py-4">
            <div className="text-center">
              <p className="text-3xl font-bold text-red-500">10+</p>
              <p className="text-sm text-slate-400">ans d&apos;expérience</p>
            </div>
            <div className="text-center border-x border-slate-700">
              <p className="text-3xl font-bold text-red-500">5000+</p>
              <p className="text-sm text-slate-400">réparations/an</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-red-500">4.6★</p>
              <p className="text-sm text-slate-400">sur Google</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a href={BUSINESS_PHONE_LINK}>
              <Button size="lg" className="w-full sm:w-auto bg-red-600 hover:bg-red-700 h-14 px-8 gap-2 text-lg font-semibold shadow-lg shadow-red-600/30" data-testid="phone-hero-call-btn">
                <Phone className="h-5 w-5" />
                05 49 05 74 90
              </Button>
            </a>
            <Link to="/rendez-vous">
              <Button size="lg" variant="outline" className="w-full sm:w-auto h-14 px-8 gap-2 border-2 border-white/30 text-white hover:bg-white/10 text-lg">
                Prendre rendez-vous
                <ArrowRight className="h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>

        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://customer-assets.emergentagent.com/job_b23b68ca-96f4-4732-840a-c86194f2a639/artifacts/1v4afdug_IMGP9228.jpg"
              alt="Vitrine Mediastore - Techniciens Certifiés Apple à Niort"
              className="w-full h-[450px] object-cover"
              loading="eager"
              width="600"
              height="450"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
          </div>

          <div className="absolute -bottom-4 -left-4 bg-white text-slate-900 rounded-xl shadow-2xl p-5 hidden md:block">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-slate-900 flex items-center justify-center">
                <AppleLogo className="h-7 w-7 text-white" />
              </div>
              <div>
                <p className="font-bold text-lg">Apple Certified</p>
                <p className="text-slate-500">Techniciens certifiés</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
